import React, { useState } from 'react'
import { Button } from '../../lib/ui/button'
import { apiPatch } from '../../util/api'
import SetTimelineForm from './SetTimelineForm'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from '../../lib/ui/dialog'
import { store } from '../../lib/store'
import { setTimeline, setDesiredTimeline } from './ActionPlanSlice'
import { getUserTrackerSections } from './index'
import { TimeIcon } from './TrackTileComponents/icons'
import { useTranslation } from '~/hooks/useTranslation'

const SetTimelineDialog = ({
  showDialog,
  toggleDialog,
  timeline,
  children,
}) => {
  const [newTimeline, setNewTimeline] = useState(timeline)
  const { t } = useTranslation('')

  const updateTimeline = async () => {
    const res = await apiPatch(`/trackers/set_timeline`, {
      tracker: { desired_timeline: newTimeline },
    })

    const data = res.data

    if (res.status === 200) {
      getUserTrackerSections()
      const timeLineText =
        data.trackerTimeline == 0 || data.trackerTimeline == null
          ? t('no_set_timeline')
          : data.trackerTimeline +
            ' ' +
            (data.trackerTimeline == 1 ? t('month') : t('months'))

      store.dispatch(setTimeline(timeLineText))
      store.dispatch(setDesiredTimeline(data.trackerTimeline))

      return res
    } else {
      throw new Error('res not ok')
    }
  }

  const handleSave = () => {
    toggleDialog()
    if (newTimeline) {
      updateTimeline()
    }
  }
  return (
    <Dialog open={showDialog} onOpenChange={toggleDialog}>
      <DialogTrigger asChild className="cursor-pointer">
        {children}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('set_your_desired_timeline')}</DialogTitle>
          <TimeIcon className="h-6 w-6" variant="light" />
        </DialogHeader>
        <SetTimelineForm setNewTimeline={setNewTimeline} />
        <DialogFooter className="pb-4">
          <Button onClick={handleSave}>{t('save')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
export default SetTimelineDialog
